import { MutationHookOptions, gql } from '@apollo/client';

import { edeApplicationQuery } from 'routes/marketplace-ede/queries/ede/getEdeApplication';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'UPDATE_APP';

const useUpdateEdeAppMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const UPDATE_EDE_APP_MUTATION = gql`
    mutation UpdateEdeApplication($appID: ID!, $edePayload: Object!) {
      ${queryName} (appID: $appID, edePayload: $edePayload) {
        ${edeApplicationQuery}
      }
    }
  `;

  return useEdeMutation(UPDATE_EDE_APP_MUTATION, options);
};

export default useUpdateEdeAppMutation;
